const months = state => state.months
const summary = state => state.summary
const statusSummary = state => state.status.summary
const selectedYear = state => state.selectedYear
const bulkLatestMonth = state => state.bulkLatestMonth
const bulkRequestInfo = state => state.bulkRequestInfo
const bulkJobs = state => state.bulkJobs
const statusBulkJobs = state => state.status.bulkJobs
const statusBulkRequest = state => state.status.bulkRequest
export default {
    months,
    summary,
    statusSummary,
    selectedYear,
    bulkLatestMonth,
    bulkRequestInfo,
    bulkJobs,
    statusBulkJobs,
    statusBulkRequest
}
